/* eslint-disable @typescript-eslint/no-explicit-any */
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { getRestEndpoint } from 'src/app/helpers/api-url';

import { IPayerAPI } from '../../interfaces/payer/payers.interface';

@Injectable({
  providedIn: 'root',
})
export class PayerService {
  constructor(private http: HttpClient) {}

  createPayer(payer: IPayerAPI): Observable<any> {
    return this.http.post<any>(`${getRestEndpoint()}/payers`, payer).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => {
          return error;
        });
      }),
    );
  }

  editPayer(payer: IPayerAPI): Observable<any> {
    const ID = payer.id;
    return this.http.put<any>(`${getRestEndpoint()}/payers/${ID}`, payer).pipe(
      catchError((error: HttpErrorResponse) => {
        return throwError(() => {
          return error;
        });
      }),
    );
  }
}
